module.exports = __webpack_public_path__ + "components/assets/logo-moka-white-15ad7fa671586385e380ab817a9e2ec3.png";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/components/assets/logo-moka-white.png
// module id = 206
// module chunks = 0 1